import React, { FC, useEffect } from 'react';
import styles from './GoogleMaps.module.scss';
import Marker, { MarkerProps } from '../Marker/Marker';
import { Map, useMap } from '@vis.gl/react-google-maps';
import { useMapsKeys } from '../../../utils/config-store';

export interface GoogleMapsProps {
  markers: MarkerProps[];
}

const GoogleMaps: FC<GoogleMapsProps> = ({ markers }) => {
  const { mapId } = useMapsKeys();

  const map = useMap();
  useEffect(() => {
    if (!map) {
      return;
    }

    const bounds = new window.google.maps.LatLngBounds();
    markers.forEach(({ lat, lng }) => bounds.extend({ lat, lng }));
    map.fitBounds(bounds);
  }, [map, markers]);

  return (
    mapId && (
      <Map
        mapId={mapId}
        className={styles.map}
        fullscreenControl={false}
        mapTypeControl={false}
        streetViewControl={false}
        defaultZoom={15}
        defaultCenter={{ lat: 61.9241, lng: 25.7482 }}
      >
        {markers.map((marker, index) => (
          <Marker key={index} {...marker} />
        ))}
      </Map>
    )
  );
};

export default GoogleMaps;
